// API Configuration
// In development, connects to production API (or local if configured)
// In production, uses environment variables

export interface ApiConfig {
  serviceUrl: string
  webUrl: string
  oauthClientId: string
}

// Default to production API for development testing
const DEFAULT_CONFIG: ApiConfig = {
  serviceUrl: 'https://api.zaprojektuj-ogrod.pl',
  webUrl: 'https://www.zaprojektuj-ogrod.pl',
  oauthClientId: 'YDytAdxXzhCrBbAcGMZEhibrTmHEcH2rCa37AJwU'
}

export function getConfig(): ApiConfig {
  // Check for environment variable overrides (set at build time or runtime)
  const serviceUrl = import.meta.env.VITE_SERVICE_URL as string | undefined
  const webUrl = import.meta.env.VITE_WEB_URL as string | undefined
  const oauthClientId = import.meta.env.VITE_OAUTH_CLIENT_ID as string | undefined

  return {
    serviceUrl: serviceUrl || DEFAULT_CONFIG.serviceUrl,
    webUrl: webUrl || DEFAULT_CONFIG.webUrl,
    oauthClientId: oauthClientId || DEFAULT_CONFIG.oauthClientId
  }
}

export const config = getConfig()
